import React from "react";
import { SHEET_SIZES } from "pages/dtf-transfers/gang-sheet/data";
import { getSheetUnitPrice } from "pages/dtf-transfers/gang-sheet/helpers";
import CheckIcon from "@mui/icons-material/Check";
import {
  StepCard,
  StepTitle,
  HelpText,
  SizeGrid,
  SizeCard,
  SizeCardHeader,
  SizeCardLabel,
  SizeCardPrice,
  VisualBar,
  ActiveCheck,
} from "styles/pages/dtf-transfers/gang-sheet";

const SheetSizePicker = ({ sheetWidth, sheetHeight, onChange }) => {
  return (
    <StepCard>
      <StepTitle>Select Sheet Size</StepTitle>
      <SizeGrid>
        {SHEET_SIZES.map((size) => {
          const isActive = size.width === sheetWidth && size.height === sheetHeight;
          const price = getSheetUnitPrice(size.width, size.height);
          return (
            <SizeCard
              key={size.id}
              $active={isActive}
              onClick={() => onChange({ sheetWidth: size.width, sheetHeight: size.height })}
            >
              <SizeCardHeader>
                <SizeCardLabel>{size.width}" × {size.height}"</SizeCardLabel>
                <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  <SizeCardPrice>${price.toFixed(2)}</SizeCardPrice>
                  {isActive && (
                    <ActiveCheck>
                      <CheckIcon style={{ fontSize: "12px", color: "#ffffff" }} />
                    </ActiveCheck>
                  )}
                </div>
              </SizeCardHeader>
              <VisualBar $height={size.height} $active={isActive} />
            </SizeCard>
          );
        })}
      </SizeGrid>
    </StepCard>
  );
};

export default SheetSizePicker;
